import { ExtensionType, getExtensions } from '@bimser/core';
import IconDocumentExcel from '@bimser/icons/16/document-excel';
import IconDocumentForm from '@bimser/icons/16/document-form';
import IconDocumentImage from '@bimser/icons/16/document-image';
import IconDocumentPDF2 from '@bimser/icons/16/document-pdf2';
import IconDocumentPowerpoint from '@bimser/icons/16/document-powerpoint';
import IconDocumentText from '@bimser/icons/16/document-text';
import IconDocumentWord from '@bimser/icons/16/document-word';
import IconDocumentVideo from '@bimser/icons/16/file-mp4';

export function getAllowedExtensionsOptions(
	allowedExtensions: string[]
): { text: string; icon: any; extensions: string[]; title: string }[] {
	return [
		{
			icon: IconDocumentWord,
			text: 'Word',
			extensions: getExtensions([ExtensionType.WordExtensionList]),
			title: allowedExtensions
				.filter(t => getExtensions([ExtensionType.WordExtensionList]).includes(t))
				.join(', ')
		},
		{
			icon: IconDocumentExcel,
			text: 'Excel',
			extensions: getExtensions([ExtensionType.ExcelExtensionList]),
			title: allowedExtensions
				.filter(t => getExtensions([ExtensionType.ExcelExtensionList]).includes(t))
				.join(', ')
		},
		{
			icon: IconDocumentPowerpoint,
			text: 'Powerpoint',
			extensions: getExtensions([ExtensionType.PowerPointExtensionList]),
			title: allowedExtensions
				.filter(t => getExtensions([ExtensionType.PowerPointExtensionList]).includes(t))
				.join(', ')
		},
		{
			icon: IconDocumentImage,
			text: 'Image',
			extensions: getExtensions([ExtensionType.ImageExtensionList]),
			title: allowedExtensions
				.filter(t => getExtensions([ExtensionType.ImageExtensionList]).includes(t))
				.join(', ')
		},
		{
			icon: IconDocumentText,
			text: 'Text',
			extensions: getExtensions([ExtensionType.TxtExtensionList]),
			title: allowedExtensions
				.filter(t => getExtensions([ExtensionType.TxtExtensionList]).includes(t))
				.join(', ')
		},
		{
			icon: IconDocumentPDF2,
			text: 'PDF',
			extensions: getExtensions([ExtensionType.PdfExtensionList]),
			title: allowedExtensions
				.filter(t => getExtensions([ExtensionType.PdfExtensionList]).includes(t))
				.join(', ')
		},
		{
			icon: IconDocumentForm,
			text: 'Form',
			extensions: getExtensions([ExtensionType.SynergyFormExtensionList]),
			title: allowedExtensions
				.filter(t => getExtensions([ExtensionType.SynergyFormExtensionList]).includes(t))
				.join(', ')
		},
		{
			icon: IconDocumentVideo,
			text: 'Video',
			extensions: getExtensions([ExtensionType.VideoExtensionList]),
			title: allowedExtensions
				.filter(t => getExtensions([ExtensionType.VideoExtensionList]).includes(t))
				.join(', ')
		}
	];
}

export function getDownloadUrl(url: string): string {
	return `${(window as any).serviceConfig.services.dm.baseURL}/${url}`;
}
